import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { User } from '../../../../front/src/types/api';
import { ChatAvatars } from './ChatAvatars';

type ChatUsersProps = {
  users: User[];
  className?: string;
};

export const ChatUsers: React.FC<ChatUsersProps> = ({ users, className }) => {
  return (
    <div
      className={twMerge(
        'ChatUsers text-lg sm:text-base font-bold text-center break p-5 text-black',
        className,
      )}
    >
      <div className="relative h-25 w-25 mx-auto mb-5">
        <ChatAvatars users={users} size="vvbig" />
      </div>

      {users.map(user => user?.profile?.pseudo).join(', ')}
    </div>
  );
};
